// viewport
const viewport = () => {
	const ua = window.navigator.userAgent.toLowerCase();
	const tablet = /android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document;
	if(window.innerWidth >= 768 && window.innerWidth <= 1152 && tablet){
		document.querySelector("meta[name='viewport']").setAttribute("content", "width=1200");
		document.body.classList.add('is-tablet');
	}
}